import Page from "../pages/layout/espFramePage";

export default [
  {
    path: "/pub_directory",
    name: "pub_directory",
    redirect: "/pub_directory/index",
    component: Page,
    children: [
      {
        path: "index",
        name: "pub_directory_index",
        meta: {title: "平台目录", isIndex: true, keepAlive: true},
        component: () => import("@/pages/pub/directory/index")
      }
    ]
  },
  {
    path: "/pub_platform",
    name: "pub_platform",
    redirect: "/pub_platform/index",
    component: Page,
    children: [
      {
        path: "index",
        name: "pub_platform_index",
        meta: {title: "二级平台", isIndex: true, keepAlive: true},
        component: () => import("@/pages/pub/platform/index")
      }
    ]
  },

  {
    path: "/pub_topplat",
    name: "pub_topplat",
    redirect: "/pub_topplat/index",
    component: Page,
    children: [
      {
        path: "index",
        name: "pub_topplat_index",
        meta: {title: "一级平台", isIndex: true, keepAlive: true},
        component: () => import("@/pages/pub/topplat/index")
      }
    ]
  },

  {
    path: "/pub_unit",
    name: "pub_unit",
    redirect: "/pub_unit/index",
    component: Page,
    children: [
      {
        path: "index",
        name: "pub_unit_index",
        meta: {title: "平台业务单元", isIndex: true, keepAlive: true},
        component: () => import("@/pages/pub/unit/index")
      }
    ]
  },

  {
    path: "/pub_user",
    name: "pub_user",
    redirect: "/pub_user/index",
    component: Page,
    children: [
      {
        path: "index",
        name: "pub_user_index",
        meta: {title: "平台用户", isIndex: true, keepAlive: true},
        component: () => import("@/pages/pub/user/index")
      }
    ]
  },

  {
    path: "/pub_user_unit",
    name: "pub_user_unit",
    redirect: "/pub_user_unit/index",
    component: Page,
    children: [
      {
        path: "index",
        name: "pub_user_unit_index",
        meta: {title: "Cookie管理", isIndex: true, keepAlive: true},
        component: () => import("@/pages/pub/userUnit/index")
      }
    ]
  },

  {
    path: "/pub_slider",
    name: "pub_slider",
    redirect: "/pub_slider/index",
    component: Page,
    children: [
      {
        path: "index",
        name: "pub_slider_index",
        meta: {title: "滑块管理",  isIndex: true, keepAlive: true},
        component: () => import("@/pages/pub/slider/index")
      }
    ]
  },

  {
    path: "/pub_slider_log",
    name: "pub_slider_log",
    redirect: "/pub_slider_log/index",
    component: Page,
    children: [
      {
        path: "index",
        name: "pub_slider_log_index",
        meta: {title: "滑块管理",  isIndex: true, keepAlive: true},
        component: () => import("@/pages/pub/silderLog/index")
      }
    ]
  },

]



// WEBPACK FOOTER //
// ./src/router/pub.js